import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'
import sLay from 'styles/modules/layout.scss'
import { Row, Col } from 'components/Layout'
import cn from 'classnames'
import s from './TrustPilot.scss'
import { range } from 'lodash'
import IconStar from 'components/Icons/Star'
import sText from 'components/Text/Text.scss'
import imgTrustPilot from 'static/images/trust-pilot.png'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
    sectionWidth={props.sectionWidth}
    style={props.centerText ? { textAlign: 'center' } : {}}
    pattern={props.pattern}
  >
    <Row className={sLay['layout-gt-xs-row']}>
      <Col className={cn(sLay['flex-gt-xs-40'])}>
        <Markdown text={props.text} color={props.color} />
        <img className={s.logo} src={imgTrustPilot} />
      </Col>
      <Col className={cn(sLay['flex-gt-xs-60'])}>
        <div className={cn(sText.heading4, sText.accent)}>Don't just take our word for it:</div>
        <Row className={cn(sLay['layout-gt-xs-row'], s.reviews)}>
          {props.reviews.map((review, idx) => (
            <Col key={idx}>
              <a
                className={s.review}
                href="https://au.trustpilot.com/review/thinkpickle.com.au"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={s.top}>
                  <div
                    className={s.avatar}
                    style={s.image ? { backgroundImage: `url(${s.image})` } : {}}
                  />
                  {range(0, review.stars).map(star => (
                    <div className={s.star} key={star}>
                      <IconStar />
                    </div>
                  ))}
                </div>
                <div>
                  <b>{review.name}</b> reviewed <b>Pickle</b>
                </div>
                <div className={s.content}>{review.content}</div>
              </a>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/TrustPilot/TrustPilot.jsx